export enum Role {
    SUPER_ADMIN = "SUPER_ADMIN",
}